module.exports = __webpack_public_path__ + "static/media/MelbourneBlue.295e9d7d.png";